import declare from "dojo/_base/declare";
import enums from "csi/enums";
import Widget from "csi/form/Widget";

const BusinessCategoryForm = declare(Widget, {
	
	/**
	 *@override
	 *Exclude Fomulated Products from FilterType dropdown
	 */
	getFieldStore(field, value) {
		if (field.getControlName() === "FilterType") {
			return enums.getStore(field.getEnumId(), null, (value) => (value !== "ProductType:Food" && value !== "ProductType:FormulatedMaterial"));
		}	

		return this.inherited(arguments);
	},
});

export = BusinessCategoryForm;